var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { ref: "scrollboxWrapper", staticClass: "fav-wrapper" }, [
    _c("div", { ref: "scrollbox" }, [
      _c("h3", { staticClass: "favorite-title" }, [_vm._v("收藏")]),
      _vm._v(" "),
      _vm.ajaxDone && _vm.favList.length
        ? _c(
            "div",
            { staticClass: "fav-list" },
            [
              _vm._l(_vm.favList, function(favs, index) {
                return _c("div", { key: index, staticClass: "fav-list-item" }, [
                  _c(
                    "div",
                    {
                      ref: "favs",
                      refInFor: true,
                      staticClass: "favs-container"
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "favs",
                          on: {
                            click: function($event) {
                              return _vm.goKBDetail(favs)
                            },
                            touchstart: function($event) {
                              return _vm.touchStart(index)
                            },
                            touchmove: function($event) {
                              return _vm.touchMove(index)
                            },
                            touchend: function($event) {
                              return _vm.touchEnd(index)
                            }
                          }
                        },
                        [
                          _c("h3", {
                            staticClass: "fav-tit",
                            domProps: { textContent: _vm._s(favs.Name) }
                          }),
                          _vm._v(" "),
                          favs.Content
                            ? _c("p", {
                                staticClass: "fav-content",
                                domProps: { textContent: _vm._s(favs.Content) }
                              })
                            : _vm._e()
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "fav-cancle",
                          on: {
                            click: function($event) {
                              return _vm.UpdateFav(favs.KBInfoId, index)
                            }
                          }
                        },
                        [_vm._v("删除")]
                      )
                    ]
                  )
                ])
              }),
              _vm._v(" "),
              _c("loading-more")
            ],
            2
          )
        : _vm._e()
    ]),
    _vm._v(" "),
    _vm.ajaxDone && !_vm.favList.length
      ? _c("div", { staticClass: "fav-empty" }, [
          _vm._v("\n        暂无内容\n    ")
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-loader/node_modules/vue-hot-reload-api")      .rerender("data-v-491ab2f5", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-491ab2f5","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/views/favorites/favorites.vue
// module id = null
// module chunks = 